module.exports = require('./helpers/bundle-url').getBundleURL('gj6jC') + "logo.c51670a8.svg";